import * as Lambda from './LambdaApi'

const postSupportRequest = async (text, registrantId, facilityId) => {
    try {
        const apiPath = `/s2l/${facilityId}/sendSupport`
        const response = await Lambda.Post(
            apiPath,
            {
                text,
                registrantId
            },
            'lambda'
        )
        if (response.success) {
            return response
        }
    } catch (err) {
        console.error(err)
    }
}

export { postSupportRequest }